import React from "react"

import Airtable from "airtable"

import { ChildSelector } from "../helpers/ChildSelector"

import * as spontaneousApplicationStyles from "../styles/SpontaneousApplication.module.css"

export default function SpontaneousApplication(props) {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const regions = React.useRef(null)

  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const [data, setData] = React.useState({
    email: ``,
    firstName: ``,
    lastName: ``,
    linkedin: ``,
    position: [
      { name: `TM1 Consulting`, checked: false },
      { name: `Software Engineering`, checked: false },
      { name: `Sales`, checked: false },
    ],
    locations: [
      { name: `Australia`, checked: false },
      { name: `Belgium`, checked: false },
      { name: `France`, checked: false },
      { name: `Germany`, checked: false },
      { name: `Hong Kong`, checked: false },
      { name: `India`, checked: false },
      { name: `Mainland China`, checked: false },
      { name: `Netherlands`, checked: false },
      { name: `Poland`, checked: false },
      { name: `Senegal`, checked: false },
      { name: `Switzerland`, checked: false },
      { name: `Taiwan`, checked: false },
      { name: `Turkey`, checked: false },
      { name: `United Kingdown`, checked: false },
      { name: `United States of America`, checked: false },
    ],
    message: ``,
  })

  const handleItemChange = (evt, cat) => {
    let updated = data
    if (Object.keys(evt.target).includes(`checked`)) {
      if (cat) {
        updated[cat].find(({ name }) => name === evt.target.name).checked =
          evt.target.checked
      } else {
        updated[evt.target.name] = evt.target.checked
      }
    } else {
      updated[evt.target.name] = evt.target.value
    }

    setData(updated, forceUpdate())
  }

  const handleSubmit = evt => {
    evt.preventDefault()

    setHasError(false)

    let filteredData = JSON.parse(JSON.stringify(data))
    filteredData[`position`] = data[`position`]
      .reduce((prev, curr) => {
        if (curr.checked) return [...prev, curr.name]
        return prev
      }, [])
      .toString()
    filteredData[`locations`] = data[`locations`]
      .reduce((prev, curr) => {
        if (curr.checked) return [...prev, curr.name]
        return prev
      }, [])
      .toString()

    const base = new Airtable({
      apiKey: process.env.GATSBY_AIRTABLE_API_TOKEN,
    }).base("appxAweck1NwVwnIE")

    base("Submissions").create(
      [
        {
          fields: filteredData,
        },
      ],
      function (err, records) {
        if (err) {
          console.error(err)
          setHasError(true)
          return
        }
        records.forEach(function (record) {
          setSubmitted(true)
        })
      },
    )
  }

  const title = ChildSelector.select(
    content,
    `spontaneous-application-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <>
      <div className={`row ${spontaneousApplicationStyles.wrapper}`}>
        <div className={`row ${spontaneousApplicationStyles.holder}`}>
          <div
            className={`col-12 ${spontaneousApplicationStyles.titleWrapper}`}
          >
            <h2
              className={`${spontaneousApplicationStyles.title}`}
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
          </div>
        </div>
        {!isSubmitted && (
          <div
            className={`row ${spontaneousApplicationStyles.jobPositionsWrapper}`}
          >
            <div
              className={`col-12 ${spontaneousApplicationStyles.personalDetails}`}
            >
              <form
                className={`row ${spontaneousApplicationStyles.applicationForm}`}
                onSubmit={handleSubmit}
              >
                <div
                  className={`col-sm-12 col-md-12 col-lg-6 col-xl-6  ${spontaneousApplicationStyles.personalDetailsWrapper}`}
                >
                  <div
                    className={`row ${spontaneousApplicationStyles.personalDetailsInnerWrapper}`}
                  >
                    <div
                      className={`col-sm-12 col-md-12 col-lg-6 col-xl-6 ${spontaneousApplicationStyles.personalDetailsFirstName}`}
                    >
                      <label class="form-control">First Name</label>
                      <input
                        id="firstName"
                        type="text"
                        className="form-control"
                        placeholder="First name *"
                        aria-label="First name"
                        name="firstName"
                        value={data.firstName}
                        required
                        onChange={handleItemChange}
                      />
                    </div>
                    <div
                      className={`col-sm-12 col-md-12 col-lg-6 col-xl-6 ${spontaneousApplicationStyles.personalDetailsLastName}`}
                    >
                      <label class="form-control" for="defaultCheck1">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Last name *"
                        aria-label="Last name"
                        id="lastName"
                        name="lastName"
                        value={data.lastName}
                        required
                        onChange={handleItemChange}
                      />
                    </div>
                    <div
                      className={`col-sm-12 col-md-12 col-lg-6 col-xl-6 ${spontaneousApplicationStyles.personalDetailsEmail}`}
                    >
                      <label class="form-control" for="defaultCheck1">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email *"
                        aria-label="Email"
                        id="email"
                        name="email"
                        value={data.email}
                        required
                        onChange={handleItemChange}
                      />
                    </div>
                    <div
                      className={`col-sm-12 col-md-12 col-lg-6 col-xl-6 ${spontaneousApplicationStyles.personalDetailsLinkedin}`}
                    >
                      <label class="form-control" for="defaultCheck1">
                        Linkedin Profile
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="LinkedIn Profile"
                        aria-label="LinkedIn"
                        id="linkedin"
                        name="linkedin"
                        value={data.linkedin}
                        onChange={handleItemChange}
                      />
                    </div>
                  </div>
                  <div
                    className={`row ${spontaneousApplicationStyles.positionLocationWrapper}`}
                  >
                    <div
                      className={`col ${spontaneousApplicationStyles.positionWrapper}`}
                    >
                      <div
                        className={`form-check ${spontaneousApplicationStyles.positionTitle}`}
                      >
                        <label className="form-check-label">
                          Type of position you're interested *
                        </label>
                      </div>
                      {data.position.map((it, idx) => (
                        <div key={idx} className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name={it.name}
                            checked={data.position[idx].checked}
                            onChange={evt => handleItemChange(evt, `position`)}
                          />
                          <label className="form-check-label">{it.name}</label>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className={`row ${spontaneousApplicationStyles.locationWrapper}`}
                  >
                    <div className={`col`}>
                      <div
                        className={`row ${spontaneousApplicationStyles.locationInnerWrapper}`}
                      >
                        <div
                          className={`col-6 ${spontaneousApplicationStyles.positionPart1}`}
                        >
                          <div
                            className={`form-check ${spontaneousApplicationStyles.locationTitle}`}
                          >
                            <label className="form-check-label">
                              Locations that interest you
                            </label>
                          </div>
                          {data.locations
                            .slice(0, Math.ceil(data.locations.length / 2))
                            .map((it, idx) => (
                              <div key={idx} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name={it.name}
                                  checked={data.locations[idx].checked}
                                  onChange={evt =>
                                    handleItemChange(evt, `locations`)
                                  }
                                />
                                <label className="form-check-label">
                                  {it.name}
                                </label>
                              </div>
                            ))}
                        </div>
                        <div
                          className={`col-6 ${spontaneousApplicationStyles.positionPart2}`}
                        >
                          <div
                            className={`form-check ${spontaneousApplicationStyles.locationTitle}`}
                          >
                            <label className="form-check-label"></label>
                          </div>
                          {data.locations
                            .slice(Math.ceil(data.locations.length / 2))
                            .map((it, idx) => (
                              <div key={idx} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name={it.name}
                                  checked={
                                    data.locations[
                                      idx + Math.ceil(data.locations.length / 2)
                                    ].checked
                                  }
                                  onChange={evt =>
                                    handleItemChange(evt, `locations`)
                                  }
                                />
                                <label className="form-check-label">
                                  {it.name}
                                </label>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`col-sm-12 col-md-12 col-lg-6 col-xl-6 ${spontaneousApplicationStyles.messageWrapper}`}
                >
                  <div>
                    <label
                      className={`${spontaneousApplicationStyles.itemMessage}`}
                    >
                      Why are you interested in joining Cubewise?
                    </label>
                    <textarea
                      className="form-control"
                      name="message"
                      rows="8"
                      values={data.message}
                      onChange={handleItemChange}
                    ></textarea>
                  </div>
                  <div
                    className={`row ${spontaneousApplicationStyles.formSubmit}`}
                  >
                    <button type="submit">Submit</button>
                    {hasError && (
                      <p>
                        An unexpected error has occurred. Please confirm all
                        data to be correctly input and try again...
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        {isSubmitted && (
          <>
            <h5>
              Thank you for your application.
              <br />
              We will be in touch soon!
            </h5>
            <br />
            <br />
            <br />
            <br />
          </>
        )}
      </div>
    </>
  )
}
